import React, { Component } from "react"

import { inIssueFilter } from "shared/search/containers/Filter/FilterCreators"

import {
    genericBarPieScene,
    genericLineScene,
} from "search-new/containers/Visualization/VisualizationScene/VisualizationScenes"

import { EventDatePickerStartFilter, EventDatePickerEndFilter } from "shared/search/containers/Filter/EventFilters"

/* *****************************************************************
 * MAPS
 ******************************************************************* */

/* *****************************************************************
 * BAR / PIE COMBO GRAPHS
 ******************************************************************* */
export const EventInIssuesBarPieScene = (props) => genericBarPieScene(props)
EventInIssuesBarPieScene.defaultProps = {
    uniqueVizSceneId: "eventInIssuesBarPieScene",
    filterId: inIssueFilter.defaultProps.uniqueFilterId,
    variableRequestKey: "inIssueFrequency",
    label: "Issues",
    icon: DjangIO.app.models.QuorumDataType.issue_management.icon,
    sidebarTableLabel: "Events tagged to Issue",
}

/* *****************************************************************
 * LINE GRAPH (TREND)
 ******************************************************************* */
export const EventTrendsScene = (props) => genericLineScene(props)
EventTrendsScene.defaultProps = {
    uniqueVizSceneId: "eventTrendsScene",
    dateStartId: EventDatePickerStartFilter.defaultProps.uniqueFilterId,
    dateEndId: EventDatePickerEndFilter.defaultProps.uniqueFilterId,
    label: "Trends",
    icon: "fa-line-chart",
}
